import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from 'react-toastify';
import { apiCallingPost } from "../api/services";
import RegexPattern from "../utils/regexPattern";
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { MdKeyboardArrowDown } from "react-icons/md";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setIsAuthenticated } from "../redux/reducers/authSlice";
import { setUserData } from "../redux/reducers/masterDataSlice";

const phoneUtil = PhoneNumberUtil.getInstance();

function SignupForm(props) {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [mobilenumber, setMobilenumber] = useState("");
  const [emailId, setemailId] = useState("");
  const [password, setPassword] = useState("");
  const [saveFlag, setSaveFlag] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [showSearch, setShowSearch] = useState(false);
  const wrapperRef = useRef(null);
  const { pageUrl } = useSelector((state) => state.authentication);
  const dispatch = useDispatch();

  useEffect(() => {
    getCountryList();
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSearch(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getCountryList = () => {
    apiCallingPost("api/common/get_country").then((data) => {
      if (data.data.success === "1") {
        const countries = data.data.result || [];
        setCountryList(countries);

        // Default select Qatar if available
        const qatar = countries.find(item => item.phone_code === "+974");
        if (qatar) setSelectedCountry(qatar);
      } else {
        toast.error(data.data.successMessage);
      }
    }).catch((error) => {
      toast.error("An error occurred. Please try again.");
    });
  };

  const isPhoneValid = (number, country) => {
    if (!country || !number) return false;
    try {
      const fullNumber = `${country.phone_code}${number}`;
      const phoneNumber = phoneUtil.parseAndKeepRawInput(fullNumber, country.country_code);
      return phoneUtil.isValidNumber(phoneNumber);
    } catch (error) {
      return false;
    }
  };

  const handleSignupForm = async (e) => {
    e.preventDefault();
    if (!name) {
      toast.error("Please enter your name.");
      document.getElementById("name").focus();
      return;
    }

    if (!selectedCountry) {
      toast.error("Please select country code");
      setShowSearch(true);
      return;
    }

    if (!mobilenumber || !isPhoneValid(mobilenumber, selectedCountry)) {
      toast.error("Please enter a valid Mobile Number");
      document.getElementById("mobilenumber").focus();
      return;
    }

    if (!emailId || !RegexPattern.Email.test(emailId)) {
      toast.error("Please enter a valid email Id");
      document.getElementById("emailId").focus();
      return;
    }

    if (!password) {
      toast.error("Please enter your password.");
      document.getElementById("password").focus();
      return;
    }
    try {
      setSaveFlag(true);
      const milliseconds = new Date().getTime();
      const postData = {
        display_name: name,
        mobile_number: mobilenumber,
        email_id: emailId,
        password: password,
        created_on: milliseconds,
        role_id: 3,
        country_id: selectedCountry?.id || ""
      };
      const data = await apiCallingPost("api/authentication/userSignup", postData);
      if (data.data.success === "1") {
        dispatch(setIsAuthenticated(true));
        dispatch(setUserData(data.data.userData[0]));
        toast.success(data.data.successMessage);
        let postData = {
          "email": emailId,
          "password": password,
          "displayName": name,
          "mobile_number": mobilenumber
        }
        console.log("........postData............", postData);

        apiCallingPost("api/authentication/create_idp_user", postData).then((data) => {
          console.log(".......data........", data);

        }).catch((error) => {
          console.log(".......error........", error);
          //props.cancelPopup();
        });
        // toast.success(data.data.successMessage);
        setTimeout(() => {
          //props.showSignup(false);
          navigate(pageUrl);
        }, 500);
      } else {
        toast.error(data.data.errorMessage);
      }
    } catch (error) {
      console.log("🚀 ~ Signup ~ error:", error)
    } finally {
      setSaveFlag(false);
    }
  };

  const customFilter = (option, inputValue) => {
    return (
      option.data.name.toLowerCase().includes(inputValue.toLowerCase()) ||
      option.data.phone_code.includes(inputValue)
    );
  };

  return (
    <div className="right_login">
      <div className="right_login_inner">
        <h2 className="right_loginhead">Sign up</h2>
        <div className="py-3 signup-sub-text">
          Sign up now and get access to exclusive content!
        </div>

        <form onSubmit={handleSignupForm}>
          <div className="form_div">
            <input
              type="text"
              id="name"
              placeholder="Name"
              className="form_login"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="form_div" ref={wrapperRef}>
            <div className="d-flex align-items-center gap-2 form-flex-class">
              <div
                className="form-select-sign"
                onClick={() => setShowSearch(!showSearch)}
              >
                {selectedCountry?.phone_code}
                <MdKeyboardArrowDown />
              </div>
              {showSearch && (
                <div className="menuIsOpen-select-country">
                  <Select
                    classNamePrefix="select"
                    id="countrySelect"
                    isSearchable
                    options={countryList}
                    value={selectedCountry}
                    onChange={(selectedOption) => {
                      setSelectedCountry(selectedOption);
                      setShowSearch(false);
                    }}
                    getOptionValue={(option) => option.id}
                    getOptionLabel={(option) => `${option.name}`}
                    filterOption={customFilter}
                    placeholder="Search country code..."
                    noOptionsMessage={({ inputValue }) =>
                      inputValue ? `No country codes found for "${inputValue}"` : "No country codes available"
                    }
                    menuIsOpen
                    autoFocus
                  />
                </div>
              )}
              <input
                type="tel"
                id="mobilenumber"
                placeholder="Mobile Number"
                className="form_login mb-0"
                value={mobilenumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  setMobilenumber(value);
                }}
                inputMode="numeric"
              />
            </div>
          </div>

          <div className="form_div">
            <input
              type="text"
              id="emailId"
              placeholder="Email Id"
              value={emailId}
              onChange={(e) => setemailId(e.target.value)}
              className="form_login"
            />
          </div>

          <div className="form_div">
            <input
              type="password"
              id="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form_login"
            />
          </div>

          <p className="forgot-pwd-sec text-end">
            <span className="signup-text">
              Already Registered?{" "}
              <span className="ms-2 cursor-pointer" onClick={() => props.showSignup(false)}>
                Back to Sign In
              </span>
            </span>
          </p>

          <button
            type="submit"
            disabled={saveFlag}
            className="login_btn"
          >
            {saveFlag ? "Signing Up..." : "Sign Up"}
          </button>
        </form>
        <div className="py-3 privacy-text">
          By clicking on Sign up, you agree to our Terms of service and Privacy policy.
        </div>

        <div className="copyright">
          © 2024 Visit Qatar. All rights reserved.
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}

export default SignupForm;
